export default {
    /**获取图片地址，只返回一个url，如果是多个图片，只返回第一个*/
    getFileUrlSingle(url) {
        if (!url) {
            return "";
        }
        let fileService = process.env.VUE_APP_FILE_URL;
        if (url.startsWith("http")) { // 是http地址
            return url;
        } else if (url.startsWith("data:")) { // 是base64编码
            return url;
        } else if (url.startsWith("{")) {// 是json字符串
            let json = JSON.parse(url);
            return this.getFileUrlSingle(json.url);
        } else if (url.startsWith("[")) { // 是json数组
            let arr = JSON.parse(url);
            if (arr.length === 0) {
                return "";
            } else {
                return this.getFileUrlSingle(arr[0].url);
            }
        }
        return fileService + url;
    },
    /**获取图片地址，返回多张图片，如果是一张图片，也返回一个数组*/
    getFileUrlMulti(url) {
        if (url.startsWith("http")) { // 是http地址
            return [url];
        } else if (url.startsWith("data:")) { // 是base64编码
            return [url];
        } else if (url.startsWith("{")) {// 是json字符串
            let json = JSON.parse(url);
            return [this.getFileUrlSingle(json.url)];
        } else if (url.startsWith("[")) { // 是json数组
            let arr = JSON.parse(url);
            let res = [];
            for (let i = 0; i < arr.length; i++) {
                res.push(this.getFileUrlSingle(arr[i]));
            }
            return res;
        }
    },
    /**下载一张图片,需求提供完整的文件路径*/
    downloadImage(url, fileName) {
        fetch(url).then(res => res.blob()).then(blob => {
            let url = window.URL.createObjectURL(blob);
            if (!fileName) {
                fileName = url.substring(url.lastIndexOf("/") + 1);
            }
            let a = document.createElement('a');
            a.href = url;
            a.download = fileName; // 文件名称
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
        })
    }
};